<template>
  <div>
    <div v-if="!showDetails">
      <app-search />
      <app-class v-for="index in classes.length" :key="index" :index="index - 1" :classes="classes[index - 1]"
        :showDetails="false" @clicked="onClickClass">
      </app-class>
    </div>
    <div v-else>
      <app-class :index="selectedCourse" :classes="classes[selectedCourse]" :sessionInfo="sessionInfo"
        :showDetails="true" @onClickDate="onClickDate" @onShowDetail="showSessionDialog = true" :date="date"
        :showFullInfo="showFullInfo" @clicked="showFullInfo = !showFullInfo">
      </app-class>
      <date-picker ref="datepicker" v-model="date" v-if="showDetails" :editable="false" :auto-submit="true"
        :min="classes[selectedCourse].StartDate" :max="TODAY" element="fileInput" @change="onChangeDate"
        :highlight="highlight" @month-change="(event) => showEvent(event)" @prev-month="(event) => showEvent(event)"
        @next-month="(event) => showEvent(event)"></date-picker>
      <input id="fileInput" ref="fileInput" />
      <div style="margin: 0 15px">
        <v-btn v-for="index in sessionCount" :key="index" class="sessionButton"
          :color="`${currentSession == index ? 'red' : 'primary'} white--text`" fab @click="changeSession(index)">
          <b> {{ index }}</b>
        </v-btn>
        <v-btn v-if="sessionCount < 5" class="sessionButton" color="primary white--text" fab @click="addSession">
          <v-icon large>mdi-plus</v-icon>
        </v-btn>
      </div>
      <div class="courses" :style="[isMobile && showFullInfo ? { top: '250px' } : '']" :key="cmKey">
        <v-row v-if="sessionInfo.AlreadyChecked">
          <v-col class="hasHozoor" xs="12">
            در این تاریخ حضور و غیاب انجام شده است.
          </v-col></v-row>
        <v-card v-for="key in students.length" :key="key" :index="key - 1">
          <app-student :student="students[key - 1]" @changed="handleState"></app-student>
        </v-card>
      </div>
      <div class="confirm">
        <v-btn class="register" :class="!isMobile ? 'btnMargin' : ''" color="primary white--text" rounded
          @click="onClosePage">
          بستن
        </v-btn>
        <v-btn class="register" color="red white--text" rounded @click="saveHozoor">
          {{ sessionInfo.AlreadyChecked ? "ثبت مجدد" : "ثبت" }}
        </v-btn>
      </div>
    </div>
    <app-dialog @close="onCloseDialog"></app-dialog>
    <v-dialog v-model="showSessionDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12">
          <b>توضیحات:</b>
        </v-col>
        <v-col class="d-flex" cols="12">
          <v-textarea outlined v-model="sessionInfo.Description" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> زمان شروع</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field :value="sessionInfo.Start" @click="onClickTime(1)" readonly></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> زمان پایان</v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field :value="sessionInfo.End" @click="onClickTime(2)" readonly></v-text-field>
        </v-col>
      </v-row>
      <br />
      <br />
      <v-row class="ltr">
        <v-btn color="green white--text" class="dialogButton" rounded @click="applyRequest" :disabled="apiRunning">
          ذخیره
        </v-btn>
        <v-btn class="dialogButton" rounded @click="cancelRequest">
          انصراف
        </v-btn>
      </v-row>
      <date-picker ref="datepicker1" v-model="sessionInfo.Start" :editable="false" :auto-submit="true"
        element="fileInput1" @change="onChangeTime($event, 1)" format="HH:mm" :jump-minute="5" :round-minute="true"
        type="time"></date-picker>
      <input id="fileInput1" ref="fileInput1" style="display: none" />
      <date-picker ref="datepicker2" v-model="sessionInfo.End" :editable="false" :auto-submit="true"
        element="fileInput2" :min="sessionInfo.Start" format="HH:mm" :jump-minute="5" :round-minute="true" type="time"
        @change="onChangeTime($event, 2)"></date-picker>
      <input id="fileInput2" ref="fileInput2" style="display: none" />
    </v-dialog>
  </div>
</template>

<script>
import Class from "./Class";
import Search from "@/components/Search";
import Student from "./Student";
import Dialog from "@/components/Dialog";
import Vue from "vue";
import { TODAY } from "@/utils/constants";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import { saveHozoor, getClassStudents, getSessionsCount } from "@/api/hozoor";
import { GetClassTimeInfo, SaveClassTimeInfo } from "@/api/classTime";

import { toArabicCharacter } from "@/utils/constants";
export default {
  components: {
    appClass: Class,
    appSearch: Search,
    datePicker: VuePersianDatetimePicker,
    appStudent: Student,
    appDialog: Dialog,
  },
  data() {
    return {
      selectedCourse: -1,
      selectedVahed: -1,

      date: TODAY,
      month: TODAY.substr(0, 7),
      TODAY: TODAY,
      changedArray: {},
      cmKey: -1,
      students: [],
      sessionInfo: {},
      sessionClone: {},
      showSessionDialog: false,
      showFullInfo: false,
      sessionCount: 1,
      monthSessionCounts: [],
      currentSession: 1,
    };
  },
  created() {

    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.$store.dispatch("getOpenClass");
  },
  computed: {
    searchInput() {
      return this.$store.getters.searchInput;
    },
    classes() {
      var classes = this.$store.getters.openClasses;
      return classes.filter((single) => {
        return (
          single.TitleName.includes(toArabicCharacter(this.searchInput)) ||
          single.TeacherName.includes(toArabicCharacter(this.searchInput))
        );
      });
    },
    classId() {
      return this.classes[this.selectedCourse].ClassID;
    },
    showDetails() {
      return this.selectedCourse > -1;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
  },
  methods: {
    showEvent(event) {
      this.month = moment(event).format("jYYYY/jMM");
      this.getSessionsCount();
    },
    /**
     * get class students
     */
    getStudentsOfClass() {
      getClassStudents(this.classId, this.date, this.currentSession)
        .then((response) => {
          this.students = response.data;
          this.changedArray = {};
          this.students.map((obj) => {
            this.changedArray[obj.LesRegID + ""] = obj.State;
          });
          this.cmKey--;
          this.getClassTimeInfo();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    getClassTimeInfo() {
      GetClassTimeInfo({
        Srl_TeacherTitle: this.classId,
        Date: this.date,
        SessionInDay: this.currentSession,
      })
        .then((response) => {
          this.sessionClone = { ...response.data };
          this.sessionInfo = { ...response.data };
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    addSession() {
      this.sessionCount++;
      this.currentSession = this.sessionCount;
      this.$store.commit(
        "SET_SNACKBAR_TEXT",
        "جلسه جدیدی ایجاد شد. " +
        "لطفا پیش از افزودن جلسه، در صورت نیاز لیست را ذخیره فرمایید."
      );
    },
    changeSession(index) {
      this.$store.commit(
        "SET_SNACKBAR_TEXT",

        "لطفا پیش از تغییر جلسه، در صورت نیاز لیست را ذخیره فرمایید."
      );
      this.currentSession = index;
    },
    getSessionsCount() {
      getSessionsCount(this.classId, this.month)
        .then((response) => {
          this.monthSessionCounts = response.data;
          if (this.monthSessionCounts[this.date]) {
            this.sessionCount = Math.max(this.monthSessionCounts[this.date], 1);
          } else this.sessionCount = 1;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    applyRequest() {
      var text = "";

      if (this.sessionInfo.Start == "") {
        text = "زمان شروع بایستی انتخاب شود.";
      } else if (this.sessionInfo.End == "") {
        text = "زمان پایان بایستی انتخاب شود.";
      } else if (this.sessionInfo.End <= this.sessionInfo.Start) {
        text = "زمان شروع از زمان پایان بزرگتر است.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        // this.$store.commit("SET_API_RUNNING", true);
        SaveClassTimeInfo(this.sessionInfo)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showSessionDialog = false;
            this.getClassTimeInfo();
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    cancelRequest() {
      this.sessionInfo = { ...this.sessionClone };
      this.showSessionDialog = false;
    },
    onClickClass(index) {

      this.selectedVahed = -1;
      window.scrollTo(0, 0);


      this.$store.commit("SET_HEADER_TITLE", "ثبت حضور و غیاب");
      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });

    },
    /**
     * close after register dialog
     */
    onCloseDialog() {
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    onClosePage() {

      this.$store.commit("SET_HEADER_TITLE", "لیست کلاس ها");

      this.date = this.TODAY;
      window.scrollTo(0, 300);
      window.history.back();
    },
    /**
     * use click on select date
     */
    onClickDate() {
      this.$store.commit(
        "SET_SNACKBAR_TEXT",
        "لطفا پیش از تغییر تاریخ، در صورت نیاز لیست را ذخیره فرمایید."
      );

      this.$refs.fileInput.click();
    },
    /**
     * after select date
     */
    onChangeDate($event) {
      this.date = moment($event).format("jYYYY/jMM/jDD");

      this.getSessionsCount();
      this.currentSession = 1;
      this.getStudentsOfClass();

      //app.$forceUpdate();
    },
    onClickTime(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeTime($event, input) {
      if (input == 1) {
        this.sessionInfo.Start = $event.format("HH:mm");
      } else {
        this.sessionInfo.End = $event.format("HH:mm");
      }
    },
    /**
     * if staudent state has changed add it to array
     */
    handleState(oldValue, newValue, regID) {
      if (oldValue != newValue) {
        this.changedArray[regID] = newValue;
      }
    },
    /**
     * call save hozoor api
     */
    saveHozoor() {
      var hozoorList = [];
      for (var regID in this.changedArray) {
        let data = {
          LesRegID: regID,
          State: this.changedArray[regID],
        };
        hozoorList.push(data);
      }

      saveHozoor(hozoorList, this.date, this.currentSession)
        .then((response) => {
          const data = response.data;
          if (data.Success) {
            this.$store.commit("SET_DIALOG_ICON", "check");
            this.$store.commit("SET_DIALOG_TYPE", 0);
            var message = data.Message;
            message += "<br/>";
            message +=
              "<span style=color:green>" +
              "تعداد حاضرین:" +
              this.getStateCount(hozoorList, -1) +
              "</span>";
            message += "<br/>";
            message +=
              "<span style=color:red>" +
              "تعداد غایبین:" +
              this.getStateCount(hozoorList, 2) +
              "</span>";
            message += "<br/>";
            message +=
              "<span style=color:blue>" +
              "تعداد تاخیرها:" +
              this.getStateCount(hozoorList, 0) +
              "</span>";

            this.$store.commit("SET_DIALOG_MESSAGE", message);
            this.$store.commit("SET_DIALOG_SHOW", true);
            this.getSessionsCount();

            this.getStudentsOfClass();
            // this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          } else {
            this.$store.commit("SET_DIALOG_ICON", "times");
            this.$store.commit("SET_DIALOG_TYPE", 0);

            this.$store.commit("SET_DIALOG_MESSAGE", data.Message);
            this.$store.commit("SET_DIALOG_SHOW", true);
          }
        })

        .catch((error) => { });
    },
    getStateCount(list, state) {
      return list.filter((s) => s.State == state).length;
    },
    highlight(formatted, dateMoment, checkingFor) {
      let attributes = { title: "Today is " + formatted };
      if (checkingFor === "day" && this.monthSessionCounts[formatted]) {
        attributes["class"] = "highlighted";
        attributes["title"] =
          "تعداد جلسات: " + this.monthSessionCounts[formatted];
      }

      return attributes;
    },
  },

  watch: {
    currentSession() {
      console.log("called");
      this.getStudentsOfClass();
    },
    '$route'(to, from) {
      this.selectedCourse = this.$route.query.index ?? -1;
      if (this.selectedCourse > -1) {
        this.getSessionsCount();
        this.currentSession = 1;
        this.getStudentsOfClass();
      }


    }
  },
};
</script>
<style scoped>
.courses {
  top: unset !important;
}

.courses>.v-card {
  float: right;
  width: calc(100% - 30px);
}

.hasHozoor {
  margin: 25px 30px 15px;
  width: 100%;
  text-align: center;
  padding: 15px 5px;
  font-size: 110%;
  background-color: #708238;
  border-color: #64dd17;
  color: white;
  border-radius: 15px;
}

@media only screen and (min-width: 1024px) {
  .courses>.v-card {
    width: calc(50% - 30px);
  }
}

@media only screen and (min-width: 1600px) {
  .courses>.v-card {
    width: calc(33.33% - 30px);
  }
}

@media screen and (max-width: 967px) {
  .courses {
    top: 80px;
  }

  .hasHozoor {
    font-size: 100%;
  }
}

#fileInput,
#fileinput1,
#fileinput2 {
  display: none;
}

.sessionButton {
  margin: 0 5px;
}
</style>
<style lang="scss">
.highlighted {
  .vpd-day-effect {
    background-color: coral !important;
    transform: scale(1);
    opacity: 1;
  }
}
</style>
